import classNames from 'classnames';
import { useMemo } from 'react';
import { TemplateClassNames } from '../../../../types/template-layouts';
import { Product } from '../../../../types/working-model';
import { Button } from '../../../general-ui/button/button';
// import { ColorList } from '../../../general-ui/color-list/color-list';
import { ImagePreview } from '../../../general-ui/image-preview/image-preview';
import ModalComponent from '../../../general-ui/modal/modal';
import { TypographyItem } from '../../../general-ui/typography-item/typography-item';
import { stylingOverrideReturns } from '../../utils';
import './product-details-modal.scss';

interface Props {
	product: Product;
	template: TemplateClassNames;
	layout_type: unknown;
	stylingOverrides: stylingOverrideReturns;
	onClose: () => void;
	language: string
}
export const ProductDetailsModal = ({
	product,
	stylingOverrides,
	template,
	onClose,
	language
}: Props): JSX.Element => {

	const {
		price,
		sale_price,
		product_title,
		description,
		images,
		button_text,
		buy_now_link
	} = product;

	const {
		moduleTitleOverrides,
		moduleCustomHeadingOverrides,
		moduleDescriptionOverrides,
		primaryButtonOverrides,
	} = stylingOverrides;

	const buyNowLink = useMemo(() => {
		if (!buy_now_link) return null;

		if (!buy_now_link.startsWith('http')) {
			return `https://${buy_now_link}`;
		}

		return buy_now_link;
	}, [buy_now_link]);

	return (
		<ModalComponent
			className={classNames(
				'ev-modal-wrapper live-event-container product-details-modal',
				template
			)}
			title=""
			open={true}
			onRequestClose={onClose}
			closeable
			cancellable
			eventPreview
		>
			<div className="product-details-modal-content">
				<div className="product-details-gallery">
					<ImagePreview
						options={images.map((imageUrl) => ({ imageUrl }))}
						arialLabel={(product_title[language] ?? product_title.base!) as string}
						template={template}
					/>
				</div>

				<div className="product-details-content">
					<TypographyItem
						className={classNames('product-details-title stable', moduleTitleOverrides, {
							'evt-heading-3': template === TemplateClassNames.Apollo,
							'evt-heading-4': template !== TemplateClassNames.Apollo,
						})}
						tagName="h3"
					>
						{product_title[language]}
					</TypographyItem>
					<TypographyItem
						className={classNames('product-details-label stable', {
							'evt-caption-2': template === TemplateClassNames.Apollo,
							'evt-body-text-2': template !== TemplateClassNames.Apollo,
						})}
					>
						{/* TODO: Add section label */}
					</TypographyItem>
					{/* out of scope for MVP */}
					{/* <ColorList label="Color" template={template}/> */}

					<div className="product-details-price-container">
						<TypographyItem
							className={classNames('product-details-price stable', moduleCustomHeadingOverrides, {
								'evt-heading-3': template === TemplateClassNames.Apollo,
								'evt-heading-4': template !== TemplateClassNames.Apollo,
							})}
						>
							{
								price?.base ? (
									`$ ${sale_price?.[language] || price?.[language]}`
								) : null
							}
						</TypographyItem>
						{(sale_price?.base && price?.base) ? (
							<TypographyItem className={classNames('product-details-old-price evt-body-text-2 stable', moduleDescriptionOverrides)}>
								$ {price?.[language]}
							</TypographyItem>
						) : null}
					</div>
					<TypographyItem className={classNames('product-details-description evt-body-text-2 stable', moduleDescriptionOverrides)} tagName="p">
						{description?.[language]}
					</TypographyItem>
					{buyNowLink && (
						<Button
							classButton={classNames(
								'primary',
								primaryButtonOverrides
							)}
							template={template}
							url={buyNowLink}
							tagName="a"
						>
							{button_text[language] || button_text.base || "Buy Now"}
						</Button>
					)}
				</div>
			</div>
		</ModalComponent>
	);
};
